// extracted by mini-css-extract-plugin
export var textInput = "_k5-0";